import React, { useState, useEffect } from "react";
import Header from "../components/Header";



import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import MomentUtils from "@date-io/moment";
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { DropzoneDialog } from "material-ui-dropzone";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Button from "@material-ui/core/Button";


import { useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import CompanyProfileActions from "../actions/companyProfile.actions";
import { connect } from "react-redux";
import CampaignsActions from "../actions/campaigns.actions";


 // =========================// 
 import { CKEditor } from '@ckeditor/ckeditor5-react';
 import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// =========================== //  


const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: #efefef !important;
  border-color: black !important;
  * {
    border-color: black !important;
  }
  label {
    color: gray!important
  }
  input {
    color: black !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

const StyledHtmlEditor = styled(Container)`
  margin-bottom: 10px;
  background: #efefef !important;
  border-color: black !important;
  * {
    border-color: black !important;
  }
  label {
    color: gray!important
  }
  input {
    color: black !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

const StyledBtn = styled(Button)`
  color: #fff !important;
  border-color: #000 !important;
  background-color: #3f3f3f !important;
  padding-left: 25px;
  padding-right: 25px;
  width: 100px;
  margin: auto;
`;

const StyledAddLogoBtn = styled(Button)`
  background: #3f3f3f !important;
  width: 300px;
  border: 1px solid #3f3f3f;
  margin-bottom: 10px;
  color: white;
`;

const ImagePreview = styled.img`
  width: 100px;
  background: white;
`;

const StyledDatePicker = styled(DatePicker)`
  margin-bottom: 10px;
  background: #efefef !important;
  border-color: black !important;
  * {
    border-color: black !important;
  }
  label {
    color: gray!important
  }
  input {
    color: black !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

const RewardRow = styled.div`
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    > div {
      width: 45%;
    }
  }
  @media (max-width: 767px) {
    width: 100%;
    > div {
      width: 100%;
    }
  }
`;

const styleObj = {
  border: "1px solid black",
  marginBottom: "20px",
  marginTop: "5px",
  backgroundColor: "#efefef"
}

const CampaignForm = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedDate, handleDateChange] = useState(new Date());
  const [files, setFiles] = useState(null);
  let match = useRouteMatch();

  useEffect(()=>{
    if (props.profile && (Object.keys(props.profile).length > 0) && !props.profile._id) {
        history.push('/profile');
    }
  },[props.profile])

  useEffect(() => {
    props.getCompanyProfile(()=>{
      if (match.params.id !== "new") {
        props.getCampaignInfo(match.params.id);
      } else {
        props.resetCampaign()
      }
    })
  }, []);
  function handleSave(files) {
    props.updateCampaignInfo({
      key: "logo",
      value: files[0],
    });
    setOpenModal(false);
  }
  var imgURL = null;
  if (props.campaign.logo && typeof props.campaign.logo != "string") {
    imgURL = (window.URL ? URL : window.webkitURL).createObjectURL(
      props.campaign.logo
    );
  }
  if (props.campaign.logo && typeof props.campaign.logo === "string") {
    imgURL = props.campaign.logo;
  }

  const campaign = props.campaign;

  const [isNew] = useState(match.params.id === "new");
  const [open, setOpen] = React.useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!props.auth.access_token) {
      history.push("/");
    }
  }, [props.auth.access_token]);

  useEffect(() => {
    if(props.campaign.multiScan === undefined) {
      props.updateCampaignInfo({
        key: "multiScan",
        value: (0)
    })
    }
  },[props.campaign.multiScan]);

  function triggerSave() {
    if (props.campaign._id) {
      props.updateCampaign({
        id: props.campaign._id,
        cb: () => {
          history.push("/campaigns");
        },
      });
    } else {
      props.createCampaign(() => {
        history.push("/campaigns");
      });
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };


  return (
    <Container fixed>
      {
        (Object.keys(props.profile).length > 0) &&
        <Header label={isNew ? null : campaign.name}  IsProfileCreated={!!props.profile._id}>
          <Typography
            component="div"
            align="left"
            style={{ marginTop: "0px", color: "black" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {imgURL && (
                <div style={{ display: "none" }}>
                  <ImagePreview src={imgURL} />
                </div>
              )}
              <StyledAddLogoBtn
                onClick={() => setOpenModal(true)}
                style={{ display: "none" }}
              >
                Add/Update Campaign Banner
              </StyledAddLogoBtn>
              <DropzoneDialog
                open={openModal}
                onSave={handleSave}
                acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={() => setOpenModal(false)}
                filesLimit={1}
              />
              <StyledTextField
                id="campaign_name"
                label="Campaign Name (for internal use only)"
                value={campaign.name || ""}
                onChange={(ev) => {
                  props.updateCampaignInfo({
                    key: "name",
                    value: ev.target.value,
                  });
                }}
                variant="outlined"
              />
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <StyledDatePicker
                  allowKeyboardControl={false}
                  value={campaign.startDate || null}
                  label="Start Date"
                  onChange={(el) => {
                    props.updateCampaignInfo({
                      key: "startDate",
                      value: el.format("MM/DD/YYYY"),
                    });
                  }}
                  inputVariant="outlined"
                  autoOk
                  format="MM/DD/YYYY"
                />
                <StyledDatePicker
                  allowKeyboardControl={false}
                  value={campaign.endDate || null}
                  label="End Date"
                  onChange={(el) => {
                    props.updateCampaignInfo({
                      key: "endDate",
                      value: el.format("MM/DD/YYYY"),
                    });
                  }}
                  inputVariant="outlined"
                  autoOk
                  format="MM/DD/YYYY"
                />
              </MuiPickersUtilsProvider>

              <InputLabel style={{marginTop:"20px", color:"black", fontStyle:"italic"}}>Redemption Instructions:</InputLabel>
              <div style={styleObj} >
                  <CKEditor 
                      editor={ ClassicEditor }
                      data={campaign.redemptionInstructions || "" }
                      config={{
                        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList']
                      }}
                      onReady={ editor => {
                          // You can store the "editor" and use when it is needed.
                          console.log( 'Editor is ready to use!', editor );
                      } }
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          props.updateCampaignInfo({
                            key: "redemptionInstructions",
                            value: data,
                          });
                      } }
                      onBlur={ ( event, editor ) => {
                          console.log( 'Blur.', editor );
                      } }
                      onFocus={ ( event, editor ) => {
                          console.log( 'Focus.', editor );
                      } }
                  />
              
              </div>
                      
              <InputLabel style={{marginTop:"20px", color:"black",fontStyle:"italic"}}>Terms & Conditions:</InputLabel>
              <div style={styleObj} >
                  <CKEditor
                      editor={ ClassicEditor }
                      data={campaign.terms || "" }
                      config={{
                        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList']
                      }}
                      onReady={ editor => {
                          // You can store the "editor" and use when it is needed.
                          console.log( 'Editor is ready to use!', editor );
                      } }
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          props.updateCampaignInfo({
                            key: "terms",
                            value: data,
                          });
                      } }
                      onBlur={ ( event, editor ) => {
                          console.log( 'Blur.', editor );
                      } }
                      onFocus={ ( event, editor ) => {
                          console.log( 'Focus.', editor );
                      } }
                  />
              
              </div>
                   
              <div style={{ display: "flex", marginTop: "20px"}}>
                <span style={{ marginRight: "20px", lineHeight: "48px" }}>
                  Campaign Status:
                </span>
                <ToggleButtonGroup
                  value={campaign.status}
                  exclusive
                  onChange={(a, value) =>
                    props.updateCampaignInfo({
                      key: "status",
                      value: value,
                    })
                  }
                  aria-label="text alignment"
                >
                  <ToggleButton value="inactive">
                    <span>Inactive</span>
                  </ToggleButton>
                  <ToggleButton value="active">
                    <span>Active</span>
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>
              <div style={{ display: "flex", marginTop: "10px" }}>
                <span style={{ marginRight: "20px", lineHeight: "48px" }}>
                  Redemption Type:
                </span>
                <ToggleButtonGroup
                  value={campaign.redemptionType}
                  exclusive
                  onChange={(a, value)=>{
                    if (!!campaign._id) {
                      return ;
                    }
                    props.updateCampaignInfo({
                      key: "redemptionType",
                      value: value,
                    })
                  }}
                  aria-label="text alignment"
                >
                  <ToggleButton
                    value="offline"
                  >
                    <span>Offline</span>
                  </ToggleButton>
                  <ToggleButton
                    value="online"
                  >
                    <span>Online</span>
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>
              <div style={{ display: "flex", marginTop: "15px" }}>
                <span style={{ marginRight: "20px", lineHeight: "48px" }}>
                  Multiscan Type:
                </span>
                <FormControl style={{ marginLeft: "20px", width:"180px" }} >
                <InputLabel id="multiScan-label">
                {campaign.multiScan === 0 ? "Not Allowed": ("Every " + campaign.multiScan + " hours")}
                </InputLabel>
                <Select
                  // labelId="multiScan-label" 
                  id="demo-controlled-open-select"
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={campaign.multiScan}
                  onChange={(a, value)=>{ 
                    document.getElementById('multiScan-label').style.display = 'none'  
                    props.updateCampaignInfo({
                      key: "multiScan",
                      value: a.target.value,
                    })
                  }}
                >
                  <MenuItem value={0}>Not Allowed</MenuItem>
                  <MenuItem value={1}>Every 1 hour</MenuItem>
                  <MenuItem value={6}>Every 6 hours</MenuItem>
                  <MenuItem value={12}>Every 12 hours</MenuItem>
                  <MenuItem value={24}>Every 24 hours</MenuItem>
                </Select>
              </FormControl>
              </div>
              {
                (campaign.redemptionType === "offline") &&
                <StyledTextField
                  id="redemptionLocation"
                  label="Redemption Location"
                  variant="outlined"
                  style={{marginTop: '10px'}}
                  disabled={!!campaign._id}
                  value={campaign.redemptionLocation || ""}
                  onChange={(ev) => {
                    props.updateCampaignInfo({
                      key: "redemptionLocation",
                      value: ev.target.value,
                    })
                  }}
                  multiline
                  rows={4}
                />
              }
              <StyledBtn
                style={{ marginTop: "10px" }}
                variant="outlined"
                color="primary"
                onClick={() => {
                  triggerSave();
                }}
              >
                Save
              </StyledBtn>
            </div>
          </Typography>
        </Header>
      }
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.companyProfile.profile,
    campaign: state.campaigns.campaign || {},
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyProfile: (cb) =>
        dispatch(CompanyProfileActions.getCompanyProfile(cb)),
    updateCampaignInfo: (payload) =>
      dispatch(CampaignsActions.updateCampaignInfo(payload)),
    createCampaign: (cb) => dispatch(CampaignsActions.createCampaign(cb)),
    getCampaignInfo: (id) => dispatch(CampaignsActions.getCampaignInfo(id)),
    updateCampaign: (payload) =>
      dispatch(CampaignsActions.updateCampaign(payload)),
    resetCampaign: ()=>{
      dispatch({
        type: 'SET_CAMPAIGN',
        payload: null
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignForm);
